<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <!-- isWaiting: the grey with global.css' waiting sweep, until the photo has loaded -->
  <figure :class="{isWaiting: !isLoaded}" @click="$emit('highlight', photo)">
    <!-- lazy: only photos near the screen are fetched (as on YouTube; 2026-10-16); grey until it
         has loaded, then shown (kept in the layout: a lazy image that isn't displayed never loads) -->
    <img
      :src="proxyUrl(photo.url_n)"
      :class="{isLoaded}"
      loading="lazy"
      alt=""
      @load="isLoaded = true" />
  </figure>
</template>

<script setup>
import {ref} from "vue";
import {getFullstackUrl} from "@/composables/useFullstackUrl";
// eslint-disable-next-line
const props = defineProps({
  photo: {type: Object, default: () => {}},
  year: {type: String, default: ""}
});
// eslint-disable-next-line
const emit = defineEmits(["highlight"]);
const isLoaded = ref(false);
const FULLSTACK = getFullstackUrl();
function proxyUrl(url) {
  return url?.replace("https://live.staticflickr.com/", `${FULLSTACK}/api/v1/thumb/flickr/`);
}
</script>

<style scoped>
figure {
  flex-grow: 1; /* https://css-tricks.com/adaptive-photo-layout-with-flexbox/ */
  width: calc(33% - 1rem);
  margin: 0;
  padding: 0;
  /* border-radius: 5px; */
  /* box-shadow: 0 5px 15px rgba(0, 0, 0, .15); */
  background: #eee; /* the placeholder, until the photo has faded in */
}
.narrow figure,
.medium figure {
  width: calc(50% - 1rem);
}
img {
  /* border-radius: 5px 5px 0 0; */
  display: block;
  width: 100%;
  height: 12.5rem; /* 200px */
  object-fit: cover;
  cursor: zoom-in;
  margin: 0;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s;
}
img.isLoaded {
  opacity: 1;
}
</style>
